import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { ProgressBar } from 'primereact/progressbar';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { toastAlert } from '../../core/utils';
import { AssignmentService } from '../../service/AssignmentService';
import ButtonsActions from '../../components/ButtonsActions';

function UpdateDesignUpload({ data, format, updateData, hide, uploadNotify, id, onAlert, closeExpand }) {
    const dataService = useRef(new AssignmentService());
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    
    const [formData, setFormData] = useState({
        fileName: '',
        urlEnglish: '',
        urlSpanish: ''
    });

    useEffect(() => {
        if (data) {
            setFormData({
                fileName: data._FILENAME || '',
                urlEnglish: data._FILEURLENGLISH || '',
                urlSpanish: data._FILEURLSPANISH || ''
            });
        }
    }, [data]);

    const handleInputChange = (field) => (e) => {
        setFormData(prev => ({ ...prev, [field]: e.target.value }));
    };

    const sendData = async () => {
        setLoading(true);
        try {
            const payload = {
                _FILENAME: formData.fileName,
                _ID: id,
                _FILEID: data._FILEID,
                _FILEURLENGLISH: formData.urlEnglish,
                _FILEURLSPANISH: formData.urlSpanish,
                _FILESTATUS: "SAVED",
            };

            const response = await dataService.current.updateDesigns(payload);
            
            if (response._SUCCESS) {
                updateData(response._ITEMS);
                uploadNotify();
                onAlert("success", response._MESSAGE);
            } else {
                onAlert("warn", response._MESSAGE);
            }
        } catch (error) {
            onAlert(error.variant, error.data);
        } finally {
            setLoading(false);
            hide();
            closeExpand();
        }
    };

    const renderUrlField = (language, value, onChange) => (
        <div className={`field ${language === 'ENGLISH' ? 'mb-5' : 'mb-8'}`}>
            <label htmlFor={`url-${language}`} className="block">
                Url from Design <b>{language}</b>
            </label>
            <span className="p-input-icon-left w-full">
                <i className="pi pi-globe text-pink-500" />
                <InputText 
                    id={`url-${language}`}
                    aria-describedby={`url-${language}-help`}
                    value={value}
                    onChange={onChange}
                    className="block w-full" 
                    placeholder='https://letusclaimcons.sharepoint.com' 
                />
            </span>
            <small id={`url-${language}-help`} className="block">
                Enter the url of the design.
            </small>
        </div>
    );

    return (
        <div className='w-full'>
            <Toast ref={toast} />
            
            <div className="field">
                <label htmlFor="name" className="block">Design Name</label>
                <span className="p-input-icon-left w-full">
                    <i className="pi pi-image text-pink-500" />
                    <InputText 
                        id="name"
                        value={formData.fileName}
                        onChange={handleInputChange('fileName')}
                        className="block w-full" 
                        placeholder='Design Campaign 001' 
                    />
                </span>
            </div>

            {data._FILEURLENGLISH && renderUrlField(
                'ENGLISH', 
                formData.urlEnglish, 
                handleInputChange('urlEnglish')
            )}

            {data._FILEURLSPANISH && renderUrlField(
                'SPANISH', 
                formData.urlSpanish, 
                handleInputChange('urlSpanish')
            )}

            <ButtonsActions
                cancel={hide}
                submit={sendData}
            />

            <LoadingDialog loading={loading} id={id} />
        </div>
    );
}

const LoadingDialog = ({ loading, id }) => (
    <Dialog visible={loading} style={{ width: '450px' }} showHeader={false} modal onHide={() => {}}>
        <div className="text-center">
            <div className="grid">
                <div className="col-12">
                    {id && (
                        <p className="text-2xl p-4"> 
                            Updating record, please wait...
                        </p>
                    )}
                </div>
                <div className="col-12">
                    <ProgressBar mode="indeterminate" className='w-full text-color h-1rem' />
                </div>
            </div>
        </div>
    </Dialog>
);

export default React.memo(UpdateDesignUpload);